import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Badge } from '@/components/ui/badge';
import { Heart } from 'lucide-react';

interface CoreValue {
  id: string;
  value_name: string;
  description: string | null;
  importance_rank: number | null;
}

interface ValuesQuickViewModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  values: CoreValue[];
}

export const ValuesQuickViewModal = ({ open, onOpenChange, values }: ValuesQuickViewModalProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Heart className="w-5 h-5 text-primary" />
            Your Core Values
          </DialogTitle>
          <DialogDescription>
            These values guide your career development goals and decisions.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 pt-2">
          {values.length === 0 ? (
            <p className="text-sm text-muted-foreground text-center py-4">
              No values discovered yet. Complete the values assessment to get started.
            </p>
          ) : (
            values.map((value, index) => (
              <div
                key={value.id}
                className="flex items-start gap-3 p-3 rounded-lg bg-muted/30 border border-border/50"
              >
                <Badge
                  variant="outline"
                  className="shrink-0 w-6 h-6 rounded-full p-0 flex items-center justify-center text-xs font-bold"
                >
                  {index + 1}
                </Badge>
                <div className="min-w-0">
                  <p className="font-medium text-sm">{value.value_name}</p>
                  {value.description && (
                    <p className="text-xs text-muted-foreground mt-0.5 line-clamp-2">
                      {value.description}
                    </p>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
